module.exports = __webpack_public_path__ + "b6d6f6fbafe1ca6f757c24635a4ab216.jpg";